import { Box } from '@/components/ui/lib/box';
import { Heading } from '@/components/ui/lib/heading';
import { Text } from '@/components/ui/lib/text';
import type { DashboardPageShellProps } from '@/app/types/dashboard-page-shell';

const DashboardPageShell = ({
  title,
  description,
  children,
  allowOverflow = false,
}: DashboardPageShellProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      minH={{ base: 'max(18rem, 100%)', md: 'max(24rem, 100%)' }}
      overflow={allowOverflow ? 'visible' : undefined}
      rounded="2xl"
      borderWidth="1px"
      p={{ base: '5', md: '7' }}
      className="border-rim bg-surface shadow-sm"
    >
      {title ? (
        <Heading
          as="h1"
          fontSize={{ base: '2xl', md: '3xl' }}
          fontWeight="700"
          className="text-base"
        >
          {title}
        </Heading>
      ) : null}
      {title && description ? (
        <Text mt="2" fontSize="sm" className="text-muted">
          {description}
        </Text>
      ) : null}
      {children ? (
        <Box mt={title ? '6' : '0'} display="flex" flexDirection="column">
          {children}
        </Box>
      ) : null}
    </Box>
  );
};

export default DashboardPageShell;
